import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import(/* webpackChunkName: "home" */ '../views/PricingView.vue')
  },
  {
    path: '/contact-us',
    name: 'ContactView',
    component: () => import(/* webpackChunkName: "home" */ '../views/ContactView.vue')
  },
  {
    path: '/blog',
    name: 'BlogView',
    component: () => import(/* webpackChunkName: "home" */ '../views/BlogView.vue')
  },
  {
    path: '/404',
    name: 'ErrorPage',
    component: () => import(/* webpackChunkName: "home" */ '../views/ErrorPage.vue')
  },
  {
    path: '/single',
    name: 'BlogSingle',
    component: () => import(/* webpackChunkName: "home" */ '../views/BlogSingle.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
